import { AbstractHook } from '@hooks/abstraction';
import { QuickReplyService } from '../services/quick-reply.service';
import { QuickReplyResponse } from '../services/responses/quick-reply.response';

export class QuickReplyHook extends AbstractHook<QuickReplyResponse, QuickReplyService> {}
